import React, { useEffect, useState } from 'react';
import { PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/solid';

// Import zdjęć (tak jak wcześniej)
import user from '../assets/user.webp';
import user2 from '../assets/user2.webp';

// Mapowanie stringów na importowane obrazy
const imageMap = {
    user: user,
    user2: user2,
    // W przyszłości możesz dodać więcej:
    // user3: user3,
};

// --- Komponent 1: Karta Członka Zespołu (Nowoczesny wygląd) ---
const TeamMemberCard = ({ member }) => {
    // Bezpieczne przypisanie obrazu - jeśli API nie poda 'user' lub 'user2', użyje domyślnego
    const memberImage = imageMap[member.imageKey] || 'https://via.placeholder.com/150';

    return (
        <div
            data-aos="fade-up"
            data-aos-delay={member.delay}
            className="group relative flex flex-col items-center text-center bg-white p-6 rounded-xl shadow-lg border border-gray-100 transition-all duration-300 hover:-translate-y-2"
        >
            {/* Zdjęcie profilowe */}
            <div className="relative w-32 h-32 -mt-16 mb-4">
                <img
                    className="w-full h-full rounded-full object-cover border-4 border-white shadow-md"
                    src={memberImage}
                    alt={member.name}
                />
            </div>

            {/* Imię i rola */}
            <h3 className="text-xl font-bold text-gray-800">{member.name}</h3>
            <p className="text-sm font-medium text-[#a07c5c] mb-4">{member.role}</p>

            {/* Dostępność */}
            <p className="text-xs text-gray-500 mb-5 flex-grow">{member.availability}</p>

            {/* Kontakt (ikony i linki) */}
            <div className="flex items-center space-x-4 border-t border-gray-200 pt-4 w-full justify-center">
                <a
                    href={`mailto:${member.email}`}
                    aria-label={`Napisz e-mail do ${member.name}`}
                    className="text-gray-400 hover:text-[#a07c5c] transition-colors"
                >
                    <EnvelopeIcon className="w-6 h-6" />
                </a>
                <a
                    href={`tel:${member.phone.replace(/\s/g, '')}`}
                    aria-label={`Zadzwoń do ${member.name}`}
                    className="text-gray-400 hover:text-[#a07c5c] transition-colors"
                >
                    <PhoneIcon className="w-6 h-6" />
                </a>
            </div>
        </div>
    );
};


// --- Komponent 2: Główny Komponent Zespołu (Przebudowany) ---
const Team = () => {
    const [teamData, setTeamData] = useState(null); // Ustawiamy null, aby łatwo sprawdzić stan ładowania
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch('https://www.wltz.space/php/src/api/zarzadzanie.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ action: 'get_management' })
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                const teamInfo = data.management?.TEAM || {};

                // Dynamiczne tworzenie listy członków
                const members = [];
                let memberIndex = 1;
                // Pętla będzie szukać `member_1_name`, `member_2_name` itd. i zatrzyma się, gdy nie znajdzie kolejnego
                while (teamInfo[`member_${memberIndex}_name`]) {
                    members.push({
                        name: teamInfo[`member_${memberIndex}_name`],
                        role: teamInfo[`member_${memberIndex}_role`],
                        phone: teamInfo[`member_${memberIndex}_phone`],
                        email: teamInfo[`member_${memberIndex}_email`], // Dodane pole email
                        availability: teamInfo[`member_${memberIndex}_availability`],
                        imageKey: `user${memberIndex > 1 ? memberIndex : ''}`, // Tworzy klucze 'user', 'user2', 'user3'
                        delay: memberIndex * 100, // Opóźnienie animacji dla lepszego efektu
                    });
                    memberIndex++;
                }

                setTeamData({
                    title: teamInfo.title || 'Nasz Zespół Ekspertów',
                    subtitle: teamInfo.subtitle || 'Poznaj profesjonalistów, którzy pomogą Ci znaleźć wymarzoną nieruchomość.',
                    members,
                });
            })
            .catch(error => {
                console.error('Error fetching team data:', error);
                setError('Nie udało się załadować danych zespołu.');
            });
    }, []);

    // Stan ładowania
    if (!teamData && !error) {
        return <div className="text-center py-20">Ładowanie zespołu...</div>;
    }

    // Stan błędu
    if (error) {
        return <div className="text-center py-20 text-red-500">{error}</div>;
    }

    return (
        <section id="team" className="bg-gray-50 py-20">
            <div className="container mx-auto px-4">
                {/* Nagłówek sekcji */}
                <div className="max-w-3xl mx-auto text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
                        {teamData.title}
                    </h2>
                    <div className="w-96 h-0.5 bg-[#a07c5c] mx-auto mb-4"></div>
                    <p className="text-lg text-gray-600">
                        {teamData.subtitle}
                    </p>
                </div>

                {/* Siatka z członkami zespołu */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 max-w-4xl mx-auto mt-24">
                    {teamData.members.map((member) => (
                        <TeamMemberCard key={member.name} member={member} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Team;